'use client'

// src/UiProvider/context.tsx
import { createContext } from "react";
var context_default = createContext(null);

export {
  context_default
};
//# sourceMappingURL=chunk-5YBTZVAT.mjs.map